import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { banTeamAccess } from "../reducer/actions/groupActions/BanTeam";
import { QuizContext } from "../App";
import Loading from "../components/Loading";
import ErrorRU from "./ErrorRU";
import AccordionTeam from "../componentsRU/accordions/AccordionTeam";
import TableTeamHeader from "../componentsRU/tables/TableTeamHeader";
import TextNotYourTeam from "../componentsRU/text/TextNotYourTeam";
import TextBanTeamAccess from "../componentsRU/text/TextBanTeamAccess";

const Team = () => {
  const quizContext = useContext(QuizContext);
  const { id } = useParams();
  const dispatch = quizContext.dispatch;

  // Get all Team information
  useEffect(() => {
    const fecthData = async () => {
      try {
        const res = await axios.get(`/team/page/${id}`);
        // console.log("res.data", res.data);
        const teamPage = res.data;
        // console.log("teamPage", teamPage);
        dispatch({ type: "fetchTeamPage", teamPage });
      } catch (err) {
        const error = err.response.data.message;
        console.log("fetchTeamPageErr:", error);
        dispatch({ type: "fetchTeamPageErr", error });
      }
    }
    fecthData();
  }, [id, dispatch]);

  const ban = banTeamAccess(
    quizContext.state.teamAdminMem,
    quizContext.state.teamAdminNumTeams,
    quizContext.state.numTeamMembers,
    quizContext.state
  );

  return (
    <div>
      {quizContext.state.loading
        ? <Loading />
        : quizContext.state.errorMySQL
          || quizContext.state.errorAuth
          || quizContext.state.error === "404"
          ? <ErrorRU />
          : quizContext.state.teamMembers.filter(el => el.user_id === quizContext.state.currentUser.id).length === 0
            ? <TextNotYourTeam />
            : ban === true
              ? <TextBanTeamAccess />
              : <>
                <TableTeamHeader />
                <AccordionTeam />
              </>
      }
    </div>
  )
}

export default Team